module.exports = __webpack_public_path__ + "media/site_templates/www.concreters.company/images/our_services_3-b64e855d38a0961b528f150454ccb8fe.jpg";